// extracted by mini-css-extract-plugin
export default {"menu":"TkWRwECQVWV3FuDIdXR7","menu__icon":"p0DJlt8CJp5030vEIjzb","menu__text":"GV7os5hGiGBp1rGKqJ1j","item":"RaWo3bfVwsVf3dkXsgcg","item__chip":"rtX6DgMVkPzL1vlPoUjn","item__chip--dark":"usKtzmMaIBpoiu6G0pME","active":"Lmw2MZuJTG8MSI4Wmm1_","heading":"oswzmiwUVaUUGRyxsjF_","heading__title":"OlV1v_wjVknPVgvzmZdo","text":"ub8F_V8go46u57IYjHVI","user__actions":"NaP3LnBEEcCeavChnjXA"};
    if(module.hot) {
      // 1762455747713
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  